
import { defineComponent } from 'vue'
import { iBusinessModel } from './BusinessModelCatalogue'
import { AxiosResponse } from 'axios'
import businessModelCatalogueDescriptor from './BusinessModelCatalogueDescriptor.json'
import FabButton from '@/components/UI/KnFabButton.vue'
import KnListBox from '@/components/UI/KnListBox/KnListBox.vue'
import KnHint from '@/components/UI/KnHint.vue'

export default defineComponent({
    name: 'business-model-catalogue',
    components: {
        FabButton,
        KnListBox,
        KnHint
    },
    data() {
        return {
            businessModelCatalogueDescriptor,
            businessModelList: [] as iBusinessModel[],
            showHint: true,
            touched: false,
            loading: false
        }
    },
    async created() {
        if (this.$route.path !== '/business-model-catalogue') {
            this.showHint = false
        }
        await this.loadAllCatalogues()
    },
    methods: {
        async loadAllCatalogues() {
            this.loading = true
            await this.$http
                .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '2.0/businessmodels')
                .then((response: AxiosResponse<any>) => (this.businessModelList = response.data))
                .finally(() => (this.loading = false))
        },
        showForm(event: any) {
            this.showHint = false
            const path = event.item ? `/business-model-catalogue/${event.item.id}` : '/business-model-catalogue/new-business-model'
            if (!this.touched) {
                this.$router.push(path)
            } else {
                this.$confirm.require({
                    message: this.$t('common.toast.unsavedChangesMessage'),
                    header: this.$t('common.toast.unsavedChangesHeader'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.touched = false
                        this.$router.push(path)
                    }
                })
            }
        },
        deleteBusinessModelConfirm(event: any) {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.touched = false
                    this.deleteBusinessModel(event.item.id)
                }
            })
        },
        async deleteBusinessModel(businessModelId: number) {
            await this.$http.delete(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '2.0/businessmodels/' + businessModelId).then(() => {
                this.$store.commit('setInfo', {
                    title: this.$t('common.toast.deleteTitle'),
                    msg: this.$t('common.toast.deleteSuccess')
                })
                this.$router.replace('/business-model-catalogue')
                this.loadAllCatalogues()
            })
        },
        pageReload() {
            this.touched = false
            this.loadAllCatalogues()
        },
        onClose() {
            this.touched = false
            this.showHint = true
        }
    }
})
